import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { constants, IconInformation, Typography } from '@klarna/bubble-ui';
import { Alert, FlowContext } from 'moet-core';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import { GridContainer, Row, Column, withResponsive, VerticalRhythm } from 'mage-components';
import { ErrorAlert } from './ErrorAlert';
import { RouteTransitionWrapper } from './RouteTransitionWrapper';
/* eslint-disable no-restricted-imports */
// @ts-expect-error: FIXME
import step1 from '../../static/signup_step_lollipop_1.jpg';
/* eslint-disable no-restricted-imports */
const SplitImage = styled.div.withConfig({ displayName: "SplitImage", componentId: "sc-1jfu165" }) `
  background: ${`url(${step1}) center no-repeat`};
  background-color: ${ // @ts-expect-error: FIXME
constants.Colors.PRIMARY};
  background-size: cover;
  height: 100vh;
  width: 50vw;
  z-index: 1;
  position: fixed;
`;
const ContentBlock = styled.div.withConfig({ displayName: "ContentBlock", componentId: "sc-1krlgy7" }) `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  margin: 0 auto;
  max-width: unset;
`;
export const PspContainerComponent = ({ isMobile, subtitle, title, children = null, contentWidth = 6, info, error = undefined, }) => {
    // @ts-expect-error: FIXME
    const { navigation = {} } = useContext(FlowContext);
    return (React.createElement(RouteTransitionWrapper, { name: navigation.key, direction: navigation.direction, disabled: isRunningContextCypress(window) },
        React.createElement(GridContainer, { extraStyles: {
                overflow: 'unset',
                maxWidth: 'unset',
                display: 'flex',
                minHeight: '100vh',
                flexDirection: 'column',
            } },
            React.createElement(Row, { spacing: { mobile: 0 }, extraStyles: { flex: 1 } },
                React.createElement(Column, { columns: { mobile: 12, desktop: contentWidth > 6 ? 12 : 6 }, justify: { mobile: 'space-between' } },
                    React.createElement(Row, { justify: "center", spacing: { mobile: 0 } },
                        React.createElement(Column, { columns: { mobile: 10, tablet: 9 } },
                            React.createElement(RouteTransitionWrapper, { name: navigation.key, direction: navigation.direction, disabled: isRunningContextCypress(window) },
                                React.createElement(ContentBlock, null,
                                    React.createElement(VerticalRhythm, { spacing: { mobile: 5, tablet: 9 } }),
                                    React.createElement(VerticalRhythm, { spacing: { mobile: 5, tablet: 9 } }),
                                    isMobile ? (React.createElement(Typography, { textToken: "text-style/headings/titles/bold/primary", accessibilityPreset: "heading 1" }, title)) : (React.createElement(Typography, { textToken: "text-style/headings/titles/bold/huge", accessibilityPreset: "heading 1" }, title)),
                                    subtitle && (React.createElement(React.Fragment, null,
                                        React.createElement(VerticalRhythm, { spacing: { mobile: 6 } }),
                                        isMobile ? (React.createElement(Typography, { textToken: "text-style/text/super-paragraphs/body/regular" }, subtitle)) : (React.createElement(Typography, { textToken: "text-style/text/super-paragraphs/tall/regular" }, subtitle)))),
                                    error && (React.createElement(React.Fragment, null,
                                        React.createElement(VerticalRhythm, { spacing: { mobile: 6 } }),
                                        React.createElement(ErrorAlert, { error: error }))),
                                    info && (React.createElement(React.Fragment, null,
                                        React.createElement(VerticalRhythm, { spacing: { mobile: 6 } }),
                                        React.createElement(Alert, { content: info, icon: IconInformation }))),
                                    React.createElement(VerticalRhythm, { spacing: { mobile: 6, tablet: 10 } }),
                                    children,
                                    React.createElement(VerticalRhythm, { spacing: { mobile: 10, tablet: 12 } })))))),
                React.createElement(Column, { columns: { desktop: 6 }, display: Object.assign({ mobile: 'none', tablet: 'none' }, (contentWidth > 6 ? { desktop: 'none' } : {})) },
                    React.createElement(SplitImage, null))))));
};
PspContainerComponent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    subtitle: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    contentWidth: PropTypes.number,
    error: PropTypes.object,
    info: PropTypes.string,
};
export const PspContainer = withResponsive(PspContainerComponent);
